import {Chip} from "primereact/chip";
import {Image} from "primereact/image";
import {Badge} from "primereact/badge";

export default function TableComment(params) {


    const chipTemplate = (props) => {
        let date = new Date(parseInt(props.created_at) * 1000)
        return (

            props.is_planing && props.planing ?
                <>
                    {props.author && props.author.avatar && <Image src={'http://yii2.easytickets.pro' + props.author.avatar} title={props.author ? props.author.name : 'CRM'}/>}
                    {!props.author && <i className={'pi pi-android m-r-15'}/>}
                    {props.planing.author && props.planing.author.id !== props.author.id && props.planing.author.avatar && <><Image src={'http://yii2.easytickets.pro' + props.planing.author.avatar} title={props.planing.author ? props.planing.author.name : 'CRM'}/></>}

                    <div className={'d-flex align-items-center'}>
                        <div className={'p-chip-text'} dangerouslySetInnerHTML={{__html: props.text}}></div>
                        <time className={'m-l-10 m-r-10'}>{date.toLocaleDateString() + ', ' + date.toLocaleTimeString()}</time>
                        <Badge style={{background: props.planing.backgroundColor}} title={new Date(props.planing.start).toLocaleDateString() + ', ' + new Date(props.planing.start).toLocaleTimeString()}/>
                    </div>




                </> :
                <>
                    {props.author && props.author.avatar && <Image src={'http://yii2.easytickets.pro' + props.author.avatar} title={props.author ? props.author.name : 'CRM'}/>}
                    {!props.author && <i className={'pi pi-android m-r-15'}/>}
                    <div className={'p-chip-text'} dangerouslySetInnerHTML={{__html: props.text}}></div>
                    <time className={'m-l-10'}>{date.toLocaleDateString() + ', ' + date.toLocaleTimeString()}</time>
                </>

        )
    }

    if (params.model.text) {
        return (
            <Chip template={(props) => chipTemplate(params.model)} label={params.model.text}
                  image={params.model.author ? ('http://yii2.easytickets.pro' + params.model.author.avatar) : false}
                  icon={params.model.author ? false : 'pi pi-android'}/>
        )
    } else {
        return ('')
    }
}